<template>
  <MdModal
    :id="`${modalId}-modal`"
    class="confirm-discard-modal"
    width="var(--modal-width)"
    :isopen="isModalOpen"
    enablebackdropclick="false"
    showoverlay="true"
    :data-qa-id="`${modalId}-modal`"
    @handleclose="$emit('closeModal')"
  >
    <div slot="header" class="confirm-discard-modal__header">
      <MdTypography slot="header" tag="h5" textalign="start" color="spirits--900" variant="heading5--medium"
                    :data-qa-id="`${modalId}-modal-title`"
      >
        {{ $t('pages.bundle.draft.discard_bundle.title') }}
      </MdTypography>
    </div>
    <div slot="body" class="confirm-discard-modal__body">
      <MdTypography :id="`${modalId}-modal-description`" slot="body" tag="p" textalign="start" color="spirits--700" variant="body1--regular">
        {{ $t('pages.bundle.draft.discard_bundle.content') }}
      </MdTypography>
    </div>
    <div slot="footer" class="confirm-discard-modal__footer">
      <MdButton slot="footer" size="large" textalign="center" color="lightgrey"
                type="button" tabidx="2" :data-qa-id="`${modalId}-modal-cancel`" @click="$emit('closeModal')"
      >
        {{ $t('buttons.cancel') }}
      </MdButton>
      <MdButton slot="footer" size="large" textalign="center"
                tabidx="2" :disabled="isBundleDiscarding" :data-qa-id="`${modalId}-modal-delete`" 
                @click="$emit('confirm')"
      >
        <MdSpinner v-if="isBundleDiscarding" slot="icon-start" :aria-label="modalId" size="16" showbox="false" color="white">
        </MdSpinner>
        {{ $t('buttons.confirm') }}
      </MdButton>
    </div>
  </MdModal>
</template>

<script src="./index.js" />
<style lang="scss">
@import '../shared/modal-mixins';

.confirm-discard-modal {
  @include confirmation-modal-styles();
}
</style>
